export default {
  REQUEST: 'REQUEST',
  RESPONSE: 'RESPONSE',
  EVENT: 'EVENT',
  INFO_PILL: 'INFO_PILL',
  INFO: 'INFO',
  AGENT_EVENT: 'AGENT_EVENT',
  QUEUE_POSITION: 'QUEUE_POSITION',
  FEEDBACK: 'FEEDBACK',
  REVIEW: 'REVIEW',
  FORM: 'FORM',
  WIDGET_EVENT: 'WIDGET_EVENT',
  CHAT_END: 'CHAT_END',
  SESSON_EXPIRE: 'SESSON_EXPIRE',
  CSAT_SURVEY: 'CSAT_SURVEY',
  PERSISTENT_SURVEY: 'PERSISTENT_SURVEY',
  SURVEY: 'SURVEY',
  SUBMIT: 'SUBMIT',
  AGENTDESK_FEEDBACK: 'AGENTDESK_FEEDBACK',
  ENABLE_INPUT_FIELD: 'ENABLE_INPUT_FIELD',
  ENABLE_CHAT_INPUT_FIELD: 'ENABLE_CHAT_INPUT_FIELD',
  GENERIC: "GENERIC",
  SECURE_FORM: 'SECURE_FORM',
  CARD_INFO: 'CARD_INFO',
  LINK_GENERATION: 'LINK_GENERATION',
  SECURE_LINK: 'SECURE_LINK',
  FORM_STATUS: 'FORM_STATUS'
}
